import { toast as sonnerToast } from 'sonner';

import type { ToastProps } from '.';
import { Toast } from '.';

export function showToast(toastProps: Omit<ToastProps, 'id'>) {
  return sonnerToast.custom((id) => <Toast id={id} {...toastProps} />, {
    duration: toastProps.duration || 8000,
    position: toastProps.position ?? 'top-right',
  });
}
